import { Checkbox } from 'fukku/Checkbox'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { cx } from 'utils/cx'

import styles from './Selectable.module.scss'

interface SelectableProps {
	readonly uniqueId: string
	readonly checkboxConfig: {
		isSelected?: boolean
		onSelect: (uniqueId: string) => void
	}
}

export function Selectable({ uniqueId, checkboxConfig }: SelectableProps) {
	const { isSmall } = useResponsive()
	return (
		<Checkbox
			id={uniqueId}
			disabled={isSmall}
			className={cx(styles.checkbox, isSmall && styles.disableEvent)}
			label=''
			checked={checkboxConfig.isSelected}
			onChange={() => checkboxConfig.onSelect(uniqueId)}
		/>
	)
}
